import { render, staticRenderFns } from "./Stocks_Insuficientes_LibrosObsequio.vue?vue&type=template&id=ad79f0c4&scoped=true"
import script from "./Stocks_Insuficientes_LibrosObsequio.vue?vue&type=script&lang=js"
export * from "./Stocks_Insuficientes_LibrosObsequio.vue?vue&type=script&lang=js"
import style0 from "./Stocks_Insuficientes_LibrosObsequio.vue?vue&type=style&index=0&id=ad79f0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad79f0c4",
  null
  
)

export default component.exports